module.exports = __webpack_public_path__ + "img/logo1.abe12aff.png";